import { executeRequest, JFSRequest } from '@jfs/network'
import { jsonToGraphQLQuery } from 'json-to-graphql-query'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfigWithTraceId } from './config'

const responseParser = (response: any) => {
  return response?.data?.data !== null
    ? response?.data?.data
    : (response?.data?.errors?.[0]?.exception?.emsErrorCodeDetailsDto?.channelDesc ??
        response?.data?.errors?.[0]?.exception?.message ??
        response?.data?.errors?.[0]?.message)
}

const getBusinessHierarchyRequestBody = (searchString: string, searchBy: string) => {
  const searchByKeys: any = {
    'Entity ID': 'entityId',
  }
  const searchByKey = searchByKeys[searchBy]
  const query = {
    findEntity: {
      __args: {
        [searchByKey]: searchString,
      },
      entitySearchList: {
        group: {
          legalName: true,
          brandName: true,
          identificationNumber: true,
          status: true,
        },
        subGroup: {
          legalName: true,
          brandName: true,
          identificationNumber: true,
          status: true,
        },
        parent: {
          entityLevel: true,
          identificationNumber: true,
          businessName: true,
          status: true,
        },
        child: {
          entityLevel: true,
          identificationNumber: true,
          businessName: true,
          status: true,
        },
        entity: {
          identificationNumber: true,
          parentEntityIdentificationNumber: true,
          subGroupIdentificationNumber: true,
          businessName: true,
          type: true,
          entityLevel: true,
          status: true,
          legalName: true,
        },
      },
    },
  }
  const gqlQuery = `{${jsonToGraphQLQuery(query, { pretty: false })}}`
  console.log('getBusinessHierarchyRequestBody', gqlQuery)
  return gqlQuery
}

const getSearchRequestBody = (searchString: string, searchBy: string, pageNumber: number, pageSize: number) => {
  const searchByKeys: any = {
    'Entity ID': 'entityId',
    'Entity Name': 'legalName',
    'Mobile Number': 'mobileNumber',
    'Device Serial No.': 'deviceSerialNumber',
    VPA: 'midVpa',
    TID: 'tid',
    'Email Id': 'emailId',
    Pincode: 'pinCode',
    'Group ID': 'groupId',
    'SubGroup ID': 'subGroupId',
    'Store Code': 'storeCode',
  }

  const searchByKey = searchByKeys[searchBy]
  const query = {
    findEntity: {
      __args: {
        [searchByKey]: searchString,
        page: pageNumber,
        size: pageSize,
      },
      entitySearchList: {
        group: {
          legalName: true,
          brandName: true,
          identificationNumber: true,
          status: true,
        },
        subGroup: {
          legalName: true,
          brandName: true,
          identificationNumber: true,
          status: true,
        },
        parent: {
          entityLevel: true,
          identificationNumber: true,
          businessName: true,
          status: true,
        },
        child: {
          entityLevel: true,
          identificationNumber: true,
          businessName: true,
          status: true,
        },
        identificationNumber: true,
        entity: {
          id: true,
          parentEntityIdentificationNumber: true,
          subGroupIdentificationNumber: true,
          identificationNumber: true,
          entityLevel: true,
          type: true,
          legalName: true,
          businessName: true,
          merchantOtpDate: true,
          deviceOtpDate: true,
          status: true,
          source: true,
          ownerType: true,
          name: true,
          oldStatus: true,
          defPostingEntity: true,
          activatedAt: true,
          terminatedAt: true,
          businessProfile: {
            ownershipType: true,
            businessChannel: true,
            setUpLevel: true,
            premiseType: true,
            businessPan: true,
            webAddress: true,
            pharmacistName: true,
            storeType: true,
            pharmacyCouncilNumber: true,
            yearsInBusiness: true,
            annualRevenueSegment: true,
            id: true,
            mccCode: true,
            dailyTransactionVolume: true,
            dailyTransactionValue: true,
            marketPlace: true,
            merchIrctcFlag: true,
            agentId: true,
          },
          storeCodeDetails: {
            storeCode: true,
            format: true,
          },
          contactDetails: {
            id: true,
            salutation: true,
            mobileNumber: true,
            firstName: true,
            middleName: true,
            lastName: true,
            gender: true,
            dob: true,
            dateOfBirth: true,
            entityContactAddress: {
              addressLine1: true,
              addressLine2: true,
              pincode: true,
              city: true,
              state: true,
              countryCode: true,
              addressType: true,
            },
            country: true,
            professionalTitle: true,
            phoneExt: true,
            phone1: true,
            phone2: true,
            fax: true,
            emailId: true,
            websiteEmailId: true,
            websiteUrl: true,
            role: true,
            allowNotification: true,
            status: true,
            reasonCode: true,
            reasonMessage: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
          },
          authorisedSignatoryDetails: {
            authSigDOB: true,
            authSigFirstname: true,
            authSigMidname: true,
            authSigLastname: true,
            authSigGender: true,
            authSignDOC: true,
            authSigSalutation: true,
            locLangMerchdesc: true,
            id: true,
          },
          addressDetails: {
            id: true,
            addressType: true,
            pincode: true,
            state: true,
            countryCode: true,
            latitude: true,
            longitude: true,
            addressRole: true,
            status: true,
            reasonCode: true,
            reasonMessage: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
            addressLine1: true,
            addressLine2: true,
            addressLine3: true,
            addressLine4: true,
            city: true,
            phone1: true,
            phone2: true,
            fax: true,
            emailAddr: true,
            stateAbbrev: true,
            geoCode: true,
          },
          gstDetails: {
            id: true,
            gstin: true,
            merchantCategory: true,
            dealerCategory: true,
            typeOfBusiness: true,
            gstStateCode: true,
            consentCode: true,
            consentVersion: true,
            consentAt: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
            jioGST: true,
          },
          settlementDetails: {
            id: true,
            accountNumber: true,
            ifsCode: true,
            acctType: true,
            acctPostingType: true,
            entityAcctCurr: true,
            entityAcctId: true,
            setupCompleteInd: true,
            effectiveDate: true,
            beneficiaryName: true,
            settlementFrequency: true,
            settlPlanId: true,
            allowSettlement: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
            settlementStatus: true,
          },
          feePackageDetails: {
            id: true,
            feePkgId: true,
            startDate: true,
            endDate: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
            inheritParentFeePackage: true,
          },
          vpaDetails: {
            id: true,
            handle: true,
            is_default: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
          },
          programCategoryDetails: {
            id: true,
            programId: true,
            referenceId: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
          },
          kycDetailDetails: {
            id: true,
            documentCategory: true,
            documentName: true,
            documentNumber: true,
            docSubmitted: true,
            expiryDate: true,
            kycStatus: true,
            kycCreationDate: true,
            kycApprovalDate: true,
            kycRemarks: true,
            createdFrom: true,
            createdBy: true,
            createdAt: true,
            updatedFrom: true,
            updatedBy: true,
            updatedAt: true,
          },
        },
        terminalDetails: {
          terminalId: true,
          id: true,
          mid: true,
          deviceSerialNo: true,
          terminalType: true,
          mobileNumber: true,
          nickName: true,
          status: true,
          posMsgBrand: true,
          dailyTransactionValue: true,
          dailyTransactionVolume: true,
          terminalConfigurationDetails: {
            key: true,
            value: true,
          },
          vpaLinkings: {
            handle: true,
            id: true,
          },
          device: {
            deviceSerialNo: true,
            deviceStatus: true,
            id: true,
            deviceLinkingStatus: true,
            manufacturerName: true,
            entityIdLinkDate: true,
          },
        },
        deviceDetails: {
          deviceSerialNo: true,
          deviceStatus: true,
          deviceLinkingStatus: true,
          manufacturerName: true,
          entityIdLinkDate: true,
        },
      },
      page: {
        size: true,
        totalElements: true,
        totalPages: true,
        number: true,
      },
    },
  }

  const gqlQuery = `{${jsonToGraphQLQuery(query, { pretty: false })}}`
  console.log('fetchSearchEntityReq', gqlQuery)
  return gqlQuery
}

const getIsEntityPresentRequestBody = (searchString: string, searchBy: string) => {
  const searchByKeys: any = {
    'Entity ID': 'entityId',
  }
  const searchByKey = searchByKeys[searchBy]
  const query = {
    findEntity: {
      __args: {
        [searchByKey]: searchString,
      },
      entitySearchList: {
        entity: {
          identificationNumber: true,
        },
      },
    },
  }

  const gqlQuery = `{${jsonToGraphQLQuery(query, { pretty: false })}}`
  console.log('fetchSearchEntityReq', gqlQuery)
  return gqlQuery
}

const getCreateFlowRequestBody = (searchString: string, searchBy: string) => {
  const searchByKeys: any = {
    'Entity ID': 'entityId',
  }
  const searchByKey = searchByKeys[searchBy]
  const query = {
    findEntity: {
      __args: {
        [searchByKey]: searchString,
      },
      entitySearchList: {
        entity: {
          identificationNumber: true,
          businessName: true,
          type: true,
          entityLevel: true,
          status: true,
        },
      },
    },
  }

  const gqlQuery = `{${jsonToGraphQLQuery(query, { pretty: false })}}`
  console.log('fetchSearchEntityReq', gqlQuery)
  return gqlQuery
}

const getFiuDetails = (searchString: string, searchBy: string) => {
  const searchByKeys: any = {
    'Entity ID': 'entityId',
  }
  const searchByKey = searchByKeys[searchBy]
  const query = {
    findEntity: {
      __args: {
        [searchByKey]: searchString,
      },
      entitySearchList: {
        entity: {
          identificationNumber: true,
          businessName: true,
          type: true,
          entityLevel: true,
          status: true,
          businessProfile: {
            cin: true,
            dateOfIncorporation: true,
          },
          authorisedSignatories: {
            authSigDOB: true,
            authSigFirstname: true,
            authSigMidname: true,
            authSigLastname: true,
            authSigGender: true,
            authSignDOC: true,
            authSigSalutation: true,
            locLangMerchdesc: true,
            status: true,
            authorisedSignatoryReferenceId: true,
            reasonCode: true,
          },
        },
        beneficialOwnerEntity: {
          id: true,
          firstName: true,
          middleName: true,
          lastName: true,
          dob: true,
          status: true,
          beneficialOwnerReferenceId: true,
        },
        directorEntities: {
          din: true,
          firstName: true,
          middleName: true,
          lastName: true,
          dob: true,
          status: true,
          directorReferenceId: true,
          surrenderedDin: true,
          beginAt: true,
          endAt: true,
        },
      },
    },
  }

  const gqlQuery = `{${jsonToGraphQLQuery(query, { pretty: false })}}`
  console.log('fetchSearchEntityReq', gqlQuery)
  return gqlQuery
}

const fetchSearchEntityReq = (
  searchString: string,
  searchBy: string,
  pageNumber: number,
  pageSize: number,
  tokens: any,
  fetchQuery: string = 'ALL',
  traceId: string,
  abortController?: any,
) => {
  const { REACT_APP_ENV } = window?._env_
  const request: JFSRequest<{}> = {
    apiPath:
      /* REACT_APP_ENV === 'pp' ||  */REACT_APP_ENV === 'prod'
        ? APIEndPoints.searchEntityPPV2
        : getUrl(APIEndPoints.searchEntity),
    method: 'POST',
    cache: false,
    config: sitConfigWithTraceId(tokens, traceId, abortController),
    headers: getHeaders(),
    body:
      fetchQuery === 'ALL'
        ? getSearchRequestBody(searchString, searchBy, pageNumber, pageSize)
        : fetchQuery === 'checkEntityPresence'
          ? getIsEntityPresentRequestBody(searchString, searchBy)
          : fetchQuery === 'createFlow'
            ? getCreateFlowRequestBody(searchString, searchBy)
            : fetchQuery === 'businessHiearchy'
              ? getBusinessHierarchyRequestBody(searchString, searchBy)
              : fetchQuery === 'fiu'
                ? getFiuDetails(searchString, searchBy)
                : getSearchRequestBody(searchString, searchBy, pageNumber, pageSize),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { fetchSearchEntityReq }
